module.exports = __webpack_public_path__ + "images/agents-stats-section.1f2c92086cb2b78aa52fbb5592495b90.png";